import { render, staticRenderFns } from "./OperaCommunityReviewWindow.vue?vue&type=template&id=354e6276"
import script from "./OperaCommunityReviewWindow.vue?vue&type=script&lang=js"
export * from "./OperaCommunityReviewWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0__css-load_01c2d4ae8744e2deff273ae17f28a58e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports